import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate } from 'react-day-picker/moment';
import { isClickHit, hasPermission } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Link } from "react-router-dom";
import { registerHook, isClickTo, unregisterHook } from '../../store/clickWrapper';
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import SvgBBiconsBmNemovitostiCz from "../../img/icons/leftPanel/BBiconsBmNemovitostiCz";
import SvgBBiconsBmNemovitostiSk from "../../img/icons/leftPanel/BBiconsBmNemovitostiSk";
import SvgBBiconsBmExekuceCz from '../../img/icons/leftPanel/BBiconsBmExekuceCz';
import SvgBBiconsBmExekuceSk from '../../img/icons/leftPanel/BBiconsBmExekuceSk';
import SvgBBiconsBmAml from '../../img/icons/leftPanel/BBiconsBmAml';

import './refButtons.scss';

class AdvancedInformationButton extends React.Component {
    state = {
        expanded: false
    }

    handleMouseOut = (e) => {
        if (!isClickHit(document.querySelector(`#${this.props.id}`), e)) {
            this.setState({ expanded: false });
        }
    }
    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.expanded && !isClickTo(click, [this.items]) && this.mounted) {
                this.setState({ expanded: false });
            }
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        unregisterHook(this.hookId);
    }

    render() {
        return (
            <>
                {this.props.links ?
                    <div className="advanced-info-links">
                        {this.renderLinks()}
                    </div>
                    : this.renderButton()}
            </>
        );
    }

    renderButton() {
        return (
            <div className="more-button-advanced">
                <div className="ref-button ref-portfolio" title={this.props.translate('Report.AdvanceInformation')} onClick={() => this.setState({ expanded: !this.state.expanded })}>
                    <div className="btn-wrap">
                        <FontAwesomeIcon icon="ellipsis-v" className='search-result-icon svg-standard-fill' />
                    </div>
                    {!this.props.hideLabel && <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })}><Translate id="Report.AdvanceInformation" /></span>}
                </div>
                {this.state.expanded &&
                    <div className="more-button-items" ref={el => this.items = el} id={this.props.id} onMouseOut={(e) => this.handleMouseOut(e)} >
                        <div className="items">
                            <div style={{ paddingLeft: "1em", lineHeight: "3em" }}>
                                {this.renderLinks()}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    renderLinks() {
        if (this.props.entityInfo === null || this.props.entityInfo === undefined)
            return null;

        return (
            <>
                {(this.props.entityInfo.type === 2 || (this.props.entityInfo.type === 1 && this.props.entityInfo.reports && this.props.entityInfo.reports.primaryAttr === 1))
                    && this.createFaButton(this.props.translate("Report.AdvanceInformation.Cee"), SvgBBiconsBmExekuceCz, "/search/cee/subject", false, false, true)}
                {((this.props.entityInfo.type === 2 && (hasPermission(null, "CadastreCzPhysicalPersons") || hasPermission(null, "CadastreCzExtendedRole"))) || (this.props.entityInfo.type === 1 && (hasPermission(null, "CadastreCZRole") || hasPermission(null, "CadastreCzExtendedRole")) && this.props.entityInfo.reports && this.props.entityInfo.reports.primaryAttr === 1))
                    && this.createFaButton(this.props.translate("Report.AdvanceInformation.PropertyCz"), SvgBBiconsBmNemovitostiCz, "/search/property-cz", true)}
                {(this.props.entityInfo.type === 2 || (this.props.entityInfo.type === 1 && this.props.entityInfo.reports && this.props.entityInfo.reports.primaryAttr === 2))
                    && this.createFaButton(this.props.translate("Report.AdvanceInformation.Cre"), SvgBBiconsBmExekuceSk, "/search/cre/subject", true, true)}
                {this.props.entityInfo.type === 2 && this.createFaButton(this.props.translate("Report.AdvanceInformation.PropertySk"), SvgBBiconsBmNemovitostiSk, "/search/property-sk", true)}
                {(this.props.entityInfo.type === 2 || (this.props.entityInfo.type === 1 && this.props.entityInfo.reports && this.props.entityInfo.reports.primaryAttr === 3)) && this.createFaButton(this.props.translate("Report.AmlInfoCheck.SectionName"), SvgBBiconsBmAml, "/search/aml/subject", true)}
            </>

        );
    }

    createFaButton = (caption, icon, link, isSurname = false, city = false, entrepreneur = false, disabled = false, color = false) => {
        var Icon = icon;
        return (
            <div className={`ml-link${disabled ? " disabled" : ""} ${color ? " color" : ""}`} style={{ display: "flex" }}>
                <Link to={{ pathname: link, search: this.createOdQueryString(isSurname, city, entrepreneur) }} target={"_blank"}>
                    <div className="ml-link-inner center-content vertical">
                        {!this.props.links && <Icon className="ml-link-icon" />}
                        <span className={classnames(`ml-link-caption`, { 'is-normal': localStorage.locales_url_format === 'normal', "link-external link-orange": this.props.links, "link-internal": !this.props.links })}>{caption}</span>
                    </div>
                </Link>
            </div>
        )
    }

    applyButton(link, isSurname = false, city = false, entrepreneur = false) {
        this.props.history.push(`${link}${this.createOdQueryString(isSurname, city, entrepreneur)}`)
    }

    createOdQueryString = (isSurname, city, entrepreneur) => {
        if (isNullOrUndefined(this.props.entityInfo) && isNullOrUndefined(this.props.entityInfo.queryName) && isNullOrUndefined(this.props.entityInfo.dateOfBirth))
            return "";

        let query = `?`;
        if (this.props.entityInfo.type === 1) {
            if (this.props.entityInfo.reports && this.props.entityInfo.reports.primaryAttr === 3)
                query += `companyName=${encodeURIComponent(this.props.entityInfo.queryName)}`;
            else {
                if (entrepreneur && this.props.entityInfo.entrepreneur === true)
                    query += `entrepreneurId=${this.props.entityInfo.entityId}`;
                else
                    query += `companyId=${encodeURIComponent(this.props.entityInfo.ico)}`;
            }
        } else {
            if (!isNullOrUndefined(this.props.entityInfo.queryName))
                if (isSurname) {
                    var parts = this.props.entityInfo.queryName.split(" ");
                    query += `name=${encodeURIComponent(parts.slice(0, parts.length - 1).join(" "))}`;
                    query += `&surname=${encodeURIComponent(parts[parts.length - 1])}`;
                }
                else
                    query += `name=${encodeURIComponent(this.props.entityInfo.queryName)}`;
            if (!isNullOrUndefined(this.props.entityInfo.dateOfBirth))
                query += `&birthDate=${encodeURIComponent(formatDate(this.props.entityInfo.dateOfBirth, 'YYYY-MM-DD', 'cs'))}`;
            else if (city && !isNullOrUndefined(this.props.entityInfo.city))
                query += `&city=${encodeURIComponent(this.props.entityInfo.city)}`;
            else if (!isNullOrUndefined(this.props.entityInfo.birthYear)) {
                query += `&birthYear=${encodeURIComponent(this.props.entityInfo.birthYear)}`;
            }

        }
        return query;
    }
    createState = () => {
        if (isNullOrUndefined(this.props.entityInfo) && isNullOrUndefined(this.props.entityInfo.queryName) && isNullOrUndefined(this.props.entityInfo.dateOfBirth))
            return undefined;

        let state = {};
        if (!isNullOrUndefined(this.props.entityInfo.queryName))
            state.name = decodeURIComponent(this.props.entityInfo.queryName);
        state.additionalData = {};
        var parts = this.props.entityInfo.queryName.split(" ");
        state.additionalData.name = decodeURIComponent(parts.slice(0, parts.length - 1).join(" "));
        state.additionalData.surname = decodeURIComponent(parts[parts.length - 1]);
        if (!isNullOrUndefined(this.props.entityInfo.dateOfBirth))
            state.dob = formatDate(this.props.entityInfo.dateOfBirth, 'YYYY-MM-DD', 'cs');
        state.type = "fo";
        return state;
    }
}

export default withRouter(withLocalize(AdvancedInformationButton));